// extracted by mini-css-extract-plugin
export default {"cityChooser":"c-j_ek","cityChooser__text":"c-j_el","cityChooser__placeholder":"c-j_em","cityChooser__buttonIcon":"c-j_en"};